import {
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  Component,
} from '@angular/core';
import { EApiRequestPartKeys, EBitfApiRequestPartsNames } from '@web/enums';
import { ApiCallStateService } from '@web/core/services';
import { BitfApiRequestPart } from '../../../api-call-state/bitf-api-request-part';

@Component({
  selector: 'bitf-infinite-scroll-trigger',
  template: '',
})
export class BitfInfiniteScrollTriggerComponent implements OnInit, OnDestroy, OnChanges {
  @Input() isLoading = false;
  @Input() isActive = false;
  @Input() paginationInfo = '';
  @Input() page: number;
  @Input() size: number;
  @Input() options: IntersectionObserverInit;
  @Input() apiCallStateName: string;
  @Input() apiRequestPartKey: EApiRequestPartKeys = EApiRequestPartKeys.PAGINATION;
  @Input() apiRequestPartName: EBitfApiRequestPartsNames;
  @Output() scrolled = new EventEmitter();

  @ViewChild('anchor', { static: true }) anchorEl: ElementRef<any>;

  observer: IntersectionObserver;
  requestPart: BitfApiRequestPart;

  constructor(private apiCallStateService: ApiCallStateService) {}

  ngOnInit() {
    if (this.apiCallStateName) {
      this.requestPart = this.apiCallStateService.getRequestPart(
        this.apiCallStateName,
        this.apiRequestPartKey
      );
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const isLastPage = this.page > 0 && this.page === this.size;

    if (this.isLoading || isLastPage) {
      this.removeObserver();
    } else {
      const options: IntersectionObserverInit = {
        ...this.options,
      };
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.scrolled.emit();
            this.triggerApiCallSateUpdate();
          }
        });
      }, options);

      this.observer.observe(this.anchorEl.nativeElement);
    }
  }

  private triggerApiCallSateUpdate() {
    if (this.apiCallStateName) {
      const page = this.page !== undefined ? this.page + 1 : undefined;
      if (page !== undefined) {
        this.apiCallStateService.setStore(() => {
          this.requestPart.data = { page };
        }, this.apiCallStateName);
      } else if (this.paginationInfo !== undefined) {
        this.apiCallStateService.setStore(() => {
          this.requestPart.data = { paginationInfo: this.paginationInfo };
        }, this.apiCallStateName);
      }
    }
  }

  private removeObserver() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  ngOnDestroy() {
    this.removeObserver();
  }
}
